// extracted by mini-css-extract-plugin
export default {"dashboardWrapper":"dashboard_dashboardWrapper__pszvU","dashboardTitle":"dashboard_dashboardTitle__TzW8X"};